import { ChangeDetectionStrategy, Component, Input, computed, effect, input, model, signal } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { NavigationService } from 'src/app/services/navigation.service';
import { IProjektInfo } from 'src/app/types/IProjektInfo';

@Component({
  selector: 'app-projekt-info',
  // standalone: true,
  // imports: [],
  templateUrl: './projekt-info.component.html',
  styleUrl: './projekt-info.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjektInfoComponent {

  // input signal to use from outside the component
  showPlangebiet = input(true);
  // get projektinfo data from dataservice
  public projektInfo = computed<IProjektInfo>(() => this.dataService.projektInfo());
  public istKostenValue = computed(() => this.projektInfo().budgetaktuell == 0 ? 0 : Math.round(this.projektInfo().istkosten / this.projektInfo().budgetaktuell * 100));
  public auftragswertValue = computed(() => this.projektInfo().budgetaktuell == 0 ? 0 : Math.round(this.projektInfo().auftragswerte / this.projektInfo().budgetaktuell * 100));

  constructor(public dataService: DataService,
			  public navigationService: NavigationService
  ){ }

}
